module.exports = __webpack_public_path__ + "images/review.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/review.svg
// module id = 956
// module chunks = 0